import React from 'react';
import { MOBILE_NAV_INACTIVE_COLOR } from '../navigationColors';

/** Gift / rewards nav icon. Defaults to the shared mobile-nav idle color. */
export default function RewardsNavIconSvg({
  width = 24,
  height = 24,
  color = MOBILE_NAV_INACTIVE_COLOR,
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      style={{ color }}
      {...rest}
    >
      <path
        d="M17.5746 5.57568L1.57499 5.57568C1.02272 5.57568 0.575012 6.02339 0.575012 6.57566L0.575012 8.57561C0.575012 9.12789 1.02272 9.57559 1.57499 9.57559L17.5746 9.57559C18.1269 9.57559 18.5746 9.12789 18.5746 8.57561L18.5746 6.57566C18.5746 6.02339 18.1269 5.57568 17.5746 5.57568Z"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.57483 5.57568L9.57483 9.57559"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5746 9.5752L16.5746 16.575C16.5746 17.1055 16.3639 17.6142 15.9889 17.9892C15.6138 18.3643 15.1051 18.575 14.5747 18.575L4.57491 18.575C4.04448 18.575 3.53579 18.3643 3.16072 17.9892C2.78566 17.6142 2.57495 17.1055 2.57495 16.575L2.57495 9.5752"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.07489 5.57552C4.41187 5.57552 3.776 5.31213 3.30717 4.8433C2.83834 4.37447 2.57495 3.7386 2.57495 3.07558C2.57495 2.41255 2.83834 1.77668 3.30717 1.30785C3.776 0.839019 4.41187 0.575633 5.07489 0.575633C6.03956 0.558825 6.98488 1.02688 7.78757 1.91876C8.59026 2.81064 9.21307 4.08496 9.57479 5.57552C9.93651 4.08496 10.5593 2.81064 11.362 1.91876C12.1647 1.02688 13.11 0.558825 14.0747 0.575633C14.7377 0.575633 15.3736 0.839019 15.8424 1.30785C16.3112 1.77668 16.5746 2.41255 16.5746 3.07558C16.5746 3.7386 16.3112 4.37447 15.8424 4.8433C15.3736 5.31213 14.7377 5.57552 14.0747 5.57552"
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
